import { useState } from 'react';
import { playerTypes } from '@intigral/constant/common';
import { FlexWrapper, RentTimer } from '@intigral/shared';
import { EpgPlayerProps } from '../../types/iEpgPlayer';
import useEventTracking from '../../../../hooks/useEventTracking';
import { GenericBitmovinPlayer } from '../../../../features/player';
import { useMediaQuery } from '@intigral/hooks';
import { isEpgProgramParentalBlocked } from '../../utils/parentalControl';

export const EpgPlayer: React.FC<EpgPlayerProps> = ({
    streamingUrl,
    isStartOver,
    isRewindProgram,
    isFutureProgram,
    isSwitch,
    selectedProgram,
    startOverPlayback,
    onRewindCompleted,
    playerReadyCallback,
    sendBookmark,
    currentProgramRemainingTime,
    currentProgramDurationTimeType,
    currentProgramDuration,
}) => {
    // state
    const [isMuted, setIsMuted] = useState(false);
    const isMobile = useMediaQuery('(max-width: 924px)');

    // hooks
    const { sendLiveTVPlayingEvent, sendLiveTVBufferingEvent, sendLiveTVPlayPauseEvent, sendLiveTVSeekedEvent } =
        useEventTracking();

    const toggleMute = () => {
        setIsMuted((prev) => !prev);
    };
    if (
        !streamingUrl ||
        isFutureProgram ||
        isEpgProgramParentalBlocked(selectedProgram) ||
        selectedProgram?.channel?.isLockedEpg === true
    ) {
        return null;
    }
    return (
        <GenericBitmovinPlayer
            streamingUrl={streamingUrl}
            playerType={playerTypes.LiveTV}
            LinearAsset={selectedProgram}
            hideControlBar={false}
            streamingType={isRewindProgram ? 'catchup' : isStartOver ? 'startover' : 'live'}
            onPlaying={sendLiveTVPlayingEvent}
            onBuffering={sendLiveTVBufferingEvent}
            onPlayPause={sendLiveTVPlayPauseEvent}
            onSeeked={sendLiveTVSeekedEvent}
            startOverPlayback={startOverPlayback}
            withSimpleUIInMinimizedMode
            onCompleted={onRewindCompleted}
            playerReadyCallback={playerReadyCallback}
            sendBookmark={sendBookmark}
            toggleMute={toggleMute}
            isMuted={isMuted}
            isSwitch={isSwitch}
            header={
                currentProgramRemainingTime !== 0 ? (
                    <FlexWrapper
                        style={{
                            position: 'relative',
                            top: !isMobile ? '-0.875rem' : '0',
                            insetInlineStart: !isMobile ? '-1.5rem' : '0',
                        }}
                    >
                        <RentTimer
                            timeCount={[currentProgramRemainingTime, 'minute']}
                            timeType={currentProgramDurationTimeType}
                            expired={false}
                            inline
                            labelRemaining=""
                            isSmall
                            base={currentProgramDuration}
                        />
                    </FlexWrapper>
                ) : null
            }
        />
    );
};
